import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';

const BoardLayout = lazy(() => import('@/pages/board/pc/Board'));
const BoardList = lazy(() => import('@/pages/board/pc/BoardList'));
const BoardDetail = lazy(() => import('@/pages/board/pc/BoardDetail'));
const BoardCreate = lazy(() => import('@/pages/board/pc/BoardCreate'));
const BoardEdit = lazy(() => import('@/pages/board/pc/BoardEdit'));

const boardRoutes: RouteObject[] = [
  {
    path: '/boards',
    element: <BoardLayout />,
    children: [
      {
        index: true,
        element: <BoardList />
      },
      {
        path: ':boardId',
        element: <BoardList />
      },
      {
        path: 'articles/:articleId',
        element: <BoardDetail />
      },
      {
        path: ':boardId/create',
        element: <BoardCreate />
      },
      {
        path: ':boardId/edit',
        element: <BoardEdit />
      }
    ]
  }
];

export default boardRoutes;
